import { createFileRoute } from "@tanstack/react-router";

import ComingSoonCover from "@/components/ComingSoonCover";

import placeholder from "./-assets/placeholder-setting.png";

export const Route = createFileRoute("/_staff/software/$id/_$id/settings/")({
  component: () => <ComingSoonCover placeholderImage={placeholder} />,
});
